import { Alert, Backdrop, Box, Button, Card, CircularProgress, Container, Link, TextField, Typography } from "@mui/material";
import { ArrowBack, ArrowForward, Warning } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate} from "react-router-dom";
import { Helper } from "../services/Helper";
import { WebStorageService } from "../services/WebStorageService";
import { PartnerService } from "../services/PartnerService";
import { PartnerApplicationModel } from "../models/PartnerApplicationModel";
import { PARTNERSHIP } from "../contants/constants";

export default function PartnershipProgramStep1() {
    const [isProgressDialogOpen, setIsProgressDialogOpen] = useState(false);
    const [fullName, setFullName] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [mobile1, setMobile1] = useState('');
    const [hasError, setHasError] = useState(false);
    const [message, setMessage] = useState("");
    const [address, setAddress] = useState('');
    const navigate = useNavigate();

    const webStorageService = new WebStorageService();
    let partnerApplication: PartnerApplicationModel = webStorageService.getJson(PARTNERSHIP) || new PartnerApplicationModel({BusinessName:'',FirstName:'',LastName:'',Mobile1:'',Address:'',PartnerApplicationID:0});
    
    const partnerService = new PartnerService();

    useEffect(() => {
        if (Helper.HasValue(partnerApplication.FirstName) && Helper.HasValue(partnerApplication.LastName))
            setFullName(partnerApplication.FirstName + ' ' + partnerApplication.LastName);
        else if (Helper.HasValue(partnerApplication.FirstName))
            setFullName(partnerApplication.FirstName);
        else if (Helper.HasValue(partnerApplication.LastName))
            setFullName(partnerApplication.LastName);

        setBusinessName(partnerApplication.BusinessName);
        setMobile1(partnerApplication.Mobile1);
        setAddress(partnerApplication.Address);

    }, []);

    function onNext() {
        setIsProgressDialogOpen(true);

        let firstSpaceIndex = fullName.indexOf(" ");
        let firstName = fullName.substring(0, firstSpaceIndex);
        let lastName = fullName.substring(firstSpaceIndex + 1, fullName.length);

        if (!Helper.HasValue(firstName) || !Helper.HasValue(lastName)) {
            setHasError(true);
            setMessage("Please specify both First Name and Last Name.")
            setIsProgressDialogOpen(false);
        } else if (!Helper.HasValue(businessName)) {
            setHasError(true);
            setMessage("Business Name is required.")
            setIsProgressDialogOpen(false);
        } else if (!Helper.HasValue(mobile1)) {
            setHasError(true);
            setMessage("Mobile Phone Number is required.")
            setIsProgressDialogOpen(false);
        } else if (mobile1.length != 11) {
            setHasError(true);
            setMessage("Mobile Phone Number must consists of 11 digits")
            setIsProgressDialogOpen(false);
        } else if (mobile1.substring(0, 2) != "09") {
            setHasError(true);
            setMessage("Mobile Phone Number must starts with '09'")
            setIsProgressDialogOpen(false);
        } else if (!Helper.HasValue(address)) {
            setHasError(true);
            setMessage("Address is required.")
            setIsProgressDialogOpen(false);
        } else {
            setHasError(false);
            partnerApplication.BusinessName = businessName;
            partnerApplication.FirstName = firstName;
            partnerApplication.LastName = lastName;
            partnerApplication.Mobile1 = mobile1;
            partnerApplication.Address = address;
            
            webStorageService.setJson(PARTNERSHIP, partnerApplication);

            partnerService.Apply(partnerApplication).then(response => {
                if(response.Data != 0){
                    partnerApplication.PartnerApplicationID = response.Data;
                    webStorageService.setJson(PARTNERSHIP, partnerApplication);
                    navigate("/partnership-program-step2")
                }
                else {
                    setHasError(true);
                    setMessage("Failed to submit partnership application. Please try again later.")
                }
                setIsProgressDialogOpen(false);
            }).catch(reason => {
                setHasError(true);
                setMessage("Something went wrong. Please try again later.")
                setIsProgressDialogOpen(false);
            });
        }
    }

    function onFullNameChanged(event: any) {
        setFullName(event.target.value);
    }

    return (
        <Container>
            <Backdrop open={isProgressDialogOpen} sx={{ zIndex: 100000 }}>
                <CircularProgress color="error"></CircularProgress>
            </Backdrop>
            <Card sx={{ marginTop: { xs: 8, sm: 15 }, padding: 2, background: "#FEF9F8", marginX: "auto", maxWidth: 400, boxShadow: { xs: 'none', md: 'var(--Paper-shadow)' } }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 4 }}>
                    Ilagay ang iyong pangalan, phone number, at address ng inyong tindahan.
                </Typography>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="First Name and Last Name" type="text" placeholder="Pangalan ng partner" variant="outlined" fullWidth={true} value={fullName} onChange={(event: any) => onFullNameChanged(event)} slotProps={{ htmlInput: { maxLength: 100 } }}></TextField>
                </Box>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="Business Name" type="text" placeholder="Pangalan ng iyong negosyo" variant="outlined" fullWidth={true} value={businessName} onChange={(event: any) => setBusinessName(event.target.value)} slotProps={{ htmlInput: { maxLength: 100 } }}></TextField>
                </Box>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField label="Mobile Phone Number (11 digits)" type="tel" placeholder="Example: 09192222881" variant="outlined" fullWidth={true} value={mobile1} onChange={(event: any) => setMobile1(event.target.value)} slotProps={{ htmlInput: { maxLength: 11 } }} sx={{ letterSpacing: 10 }}></TextField>
                </Box>
                <Box sx={{ marginBottom: 4 }}>
                    <TextField onChange={(event: any) => setAddress(event.target.value)} multiline rows={2} label="Complete Address" placeholder="Number ng bahay, kalye, baranggay, city o munisipalidad." variant="outlined" fullWidth={true} value={address} slotProps={{ htmlInput: { maxLength: 250 } }}></TextField>
                </Box>
                {hasError && <Alert icon={<Warning></Warning>} severity="warning" sx={{ marginBottom: 4 }}>{message}</Alert>}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Link onClick={(e) => { e.preventDefault(); navigate("/become-our-partner"); }} variant="body2" sx={{ display: "flex", alignItems: "center", textDecoration: "none", marginY: 4, cursor: "pointer" }}><ArrowBack></ArrowBack> GO BACK</Link>
                    <Button variant="contained" sx={{ background: "#d32f2f", display: "flex", alignItems: "center" }} onClick={onNext}>NEXT <ArrowForward></ArrowForward></Button>
                </Box>
            </Card>
        </Container>
    );
}